const request = require("request");
const config = require("./config");

let getProtocolos = (token, filters) => {
    return new Promise((resolve, reject) => {
        request(
            {
                headers: {
                    "Content-Type": "application/json",
                    "User-Token": token,
                },
                uri: config.URL_BACKEND + "/protocolo",
                method: "GET",
                qs: filters,
            },
            (err, res, body) => {
                resolve(body);
            }
        );
    });
};

let getProtocoloDatas = (token, filters) => {
    return new Promise((resolve, reject) => {
        request(
            {
                headers: {
                    "Content-Type": "application/json",
                    "User-Token": token,
                },
                uri: config.URL_BACKEND + "/protocolo/protocoloDatas",
                method: "GET",
                qs: filters,
            },
            (err, res, body) => {
                resolve({ err: err, res: res, body: body });
            }
        );
    });
};
let getGerenciaPedidosProtocoloDatas = (token, filters) => {
    return new Promise((resolve, reject) => {
        request(
            {
                headers: {
                    "Content-Type": "application/json",
                    "User-Token": token,
                },
                uri: config.URL_BACKEND + "/protocolo/gerenciapedidos/protocoloDatas",
                method: "GET",
                qs: filters,
            },
            (err, res, body) => {
                resolve({ err: err, res: res, body: body });
            }
        );
    });
};

let getGerenciaPedidosProtocolo = (token, filters) => {
    return new Promise((resolve, reject) => {
        request(
            {
                headers: {
                    "Content-Type": "application/json",
                    "User-Token": token,
                },
                uri: config.URL_BACKEND + "/protocolo/gerenciapedidos/",
                method: "GET",
                qs: filters,
            },
            (err, res, body) => {
                resolve({ err: err, res: res, body: body });
            }
        );
    });
};

let getGerenciaPedidosProtocoloNF = (token, filters) => {
    return new Promise((resolve, reject) => {
        request(
            {
                headers: {
                    "Content-Type": "application/json",
                    "User-Token": token,
                },
                uri: config.URL_BACKEND + "/protocolo/gerenciapedidos/notafiscal",
                method: "GET",
                qs: filters,
            },
            (err, res, body) => {
                resolve({ err: err, res: res, body: body });
            }
        );
    });
};

module.exports = {
    getProtocolos: getProtocolos,
    getProtocoloDatas: getProtocoloDatas,
    getGerenciaPedidosProtocoloDatas: getGerenciaPedidosProtocoloDatas,
    getGerenciaPedidosProtocolo: getGerenciaPedidosProtocolo,
    getGerenciaPedidosProtocoloNF: getGerenciaPedidosProtocoloNF,
};
